module.exports = __webpack_public_path__ + "img/ICFA-logo.0bca85f.png";